import { Navigate, useLocation } from 'react-router-dom';

import { AuthGuardProps } from './AuthGuard.types';
import * as PATHS from 'constants/paths';
import { useAuthSelector, useGlobalSelector, useGlobalStore } from 'stores';

const AuthGuard = ({ children }: AuthGuardProps) => {
  const { isAuthenticated, isLoggingOut } = useAuthSelector();
  const { requestedLocation } = useGlobalSelector();

  const { pathname, search } = useLocation();

  // Controlla sempre se c'è un token SSO nell'URL (anche se già autenticato)
  const urlParams = new URLSearchParams(search);
  const ssoToken = urlParams.get('token');
  const sessionCookie = urlParams.get('session_cookie');
  const userData = urlParams.get('user_data');
  
  if (ssoToken && (sessionCookie || userData)) {
    const redirectParam = encodeURIComponent(pathname);
    let ssoUrl = `/sso?token=${ssoToken}&redirect=${redirectParam}`;
    if (sessionCookie) {
      ssoUrl += `&session_cookie=${sessionCookie}`;
    }
    if (userData) {
      ssoUrl += `&user_data=${userData}`;
    }
    return <Navigate to={ssoUrl} />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation && !isLoggingOut)
      useGlobalStore.setState({ requestedLocation: pathname });

    return <Navigate to={PATHS.LOGIN} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    useGlobalStore.setState({ requestedLocation: null });
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

export { AuthGuard };
